import { Button, Divider, Grid, MenuItem, Select, theme, Typography } from "@mzc-pdc/ui";
import { UsersMultiInputV2 } from "@features/users-input/users-multi-input-v2";
import { IconAdd } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";

const UsersInputWithTemporarySave = ({
    title,
    showCount,
    selecting,
    selected,
    actionProps,
    addButtonLabel,
    onChangeSelecting,
    onClickAddToSelected,
    userScope,
}) => {
    const { t } = useTranslation();

    return (
        <Grid container flexDirection={"column"} gap={theme.spacing(1)}>
            <Grid item>
                <Typography variant={`body1_500`}>{t(`common::label::${title}`, title)}</Typography>&nbsp;
                {showCount && (
                    <Typography variant={`body1_500`} color={theme.palette.primary.main}>
                        {selecting?.length ?? 0}
                    </Typography>
                )}
            </Grid>
            <Grid
                item
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: theme.spacing(1),
                    alignItems: "flex-end",
                }}
            >
                <UsersMultiInputV2
                    users={selecting}
                    exceptUsers={selected.concat(selecting)}
                    sx={{
                        flex: 3,
                        "& .MuiOutlinedInput-root": {
                            paddingRight: "0px !important",
                        },
                    }}
                    placeholder={t(`common::msg::Please enter user's name.`, `Please enter user's name.`)}
                    onChange={onChangeSelecting}
                    scope={userScope}
                />
                {actionProps && (
                    <Select
                        onChange={(e) => {
                            actionProps.setAction && actionProps.setAction(e.target.value);
                        }}
                        value={actionProps.action}
                        sx={{ flex: `1 0 0%`, height: "100%" }}
                    >
                        {actionProps.actionOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {t(`common::label::${option.label}`, `${option.label}`)}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            </Grid>
            <Grid
                item
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    my: theme.spacing(0.5),
                }}
            >
                <Button
                    size={"small"}
                    variant={"text"}
                    disabled={selecting.length === 0}
                    onClick={onClickAddToSelected}
                    startIcon={<IconAdd size={16} />}
                >
                    {t(`common::label::${addButtonLabel}`, addButtonLabel)}
                </Button>
            </Grid>
        </Grid>
    );
};

export default UsersInputWithTemporarySave;
